import React, { useMemo } from 'react';
import ServicePicker from 'components/ServicePicker';
import { translate } from 'components/Translation';
import { CustomAttribute, extractAttributeValue } from 'utils/ecommerce/services/extract';
import JawazakColumn from './JawazakColumn';
import { useTheme } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery/useMediaQuery';

interface ISingleJawazakTableProps {
	catalogEntryView: types.ecommerce.CatalogEntryView[];
	selectedTab: number | null;
	setSelectedTab: (selectedTabNumber: number | null) => void;
}

const SingleJawazakTable = ({ catalogEntryView, selectedTab, setSelectedTab }: ISingleJawazakTableProps) => {
	const theme = useTheme();
	const xsDown = useMediaQuery(theme.breakpoints.down('xs'));

	const maxValue = useMemo(() => {
		let _maxValue = 0;
		catalogEntryView.forEach((singleCatalogEntryView) => {
			const attributes = singleCatalogEntryView.attributes;
			let includedRoamingData = extractAttributeValue({ attributes }, CustomAttribute.INCLUDED_ROAMING_DATA);
			let value = parseInt(includedRoamingData) || 0;
			if (includedRoamingData && includedRoamingData.indexOf('MB') >= 0) {
				value = parseInt(includedRoamingData) / 1000;
			}
			_maxValue = Math.max(_maxValue, value);
		});
		return _maxValue;
	}, [catalogEntryView]);

	const tabs = useMemo(() => {
		return catalogEntryView.map((singleCatalogEntryView) => {
			const attributes = singleCatalogEntryView.attributes;
			const includedRoamingData = extractAttributeValue({ attributes }, CustomAttribute.INCLUDED_ROAMING_DATA);
			const unlimited = includedRoamingData === 'Unlimited';
			let progress = undefined;
			if (!unlimited) {
				let value = parseInt(includedRoamingData);
				if (includedRoamingData && includedRoamingData.indexOf('MB') >= 0) {
					value = parseInt(includedRoamingData) / 1000;
				}
				progress = (value / maxValue) * 100;
			}
			return {
				column: <JawazakColumn catalogEntryView={singleCatalogEntryView} />,
				numberOfCells: 2,
				header: {
					unlimited: unlimited,
					title: includedRoamingData,
					subtitle: translate('jawazak.table.roaming.data.allowance'),
					progress: progress,
					height: 110,
				},
			};
		});
	}, [catalogEntryView, maxValue]);

	return (
		<div>
			<ServicePicker
				selectedTab={selectedTab}
				setSelectedTab={setSelectedTab}
				tabs={tabs}
				numberOfTabsOnSlide={xsDown ? 1 : tabs.length > 2 ? 5 : 2}
				selectedTabColor="primary"
			/>
		</div>
	);
};

export default SingleJawazakTable;
